import { Layout } from "antd";
import { Content } from "antd/es/layout/layout";
import { useOutlet } from "react-router-dom";
import HeaderHome from "../home/HeaderHome";
import SearchSerie from "./SearchSerie";

const LayoutSerie = () => {
  const outlet = useOutlet();

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <HeaderHome />
      <Content style={{ margin: "16px 100px" }}>
        {outlet || <SearchSerie />}
      </Content>
    </Layout>
  );
};

export default LayoutSerie;
